import React, { useState, useEffect } from 'react';
import { Checkbox } from '@material-ui/core';
import API from '../../services/api';
import CancelIcon from '@material-ui/icons/Close';
import './style.css';
import { BouncingLoader } from "../../pure-components/Loader";
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ErrorToast, InfoToast, SuccessToast } from '../../pure-components/CustomToast';
import Helper from '../../services/helper';
import SaveIcon from "@material-ui/icons/SaveOutlined";
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import { InputAdornment } from '@mui/material';



function AddTrackToProjectPopup(props) {
  const [projectTitle, setProjectTitle] = useState('');
  const [projects, setProjects] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [tempProjects, setTempProjects] = useState([]);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState('');
  const [trackAddedProjects, setTrackAddedProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


const [height, setHeight] = useState('20vh');

  const updateHeight = () => {
    const width = window.innerWidth;
    if (width >= 1025) {
      setHeight('40vh'); // Laptop
    } else if (width >= 600) {
      setHeight('30vh'); // Tablet
    } else {
      setHeight('20vh'); // Mobile
    }
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight); // Listen for resize
    return () => window.removeEventListener('resize', updateHeight); // Cleanup
  }, []);

  
  useEffect(() => {
    (async () => {

      setTrackToBeAddedToProject(props.trackToBeAddedToProject);
      setIsLoading(true);
      await fetchProjects().catch((err) => {
        toast(({ closeToast }) => <ErrorToast message={`Error Loading Projects : ${err.status}: ${err?.message}`} />);
      })
    })();
  }, []);

  useEffect(() => {
  
  },[trackAddedProjects])

  const createProject = async(value) => {
    if(!(value?.length > 0))
      return;
    if(projects?.find((elem) => {
      return elem?.title?.toLowerCase() === value?.toLowerCase()
    })){
      toast(({ closeToast }) => <ErrorToast message={`Already have a project with the name : ${value}, please change the name.`} />); 
      return;
    }
    await API.createProject({ title: value }).then(async(res) => {
      setProjectTitle('');
      await fetchProjects().catch((err) => {
        toast(({ closeToast }) => <ErrorToast message={`Error Loading Projects : ${err.status}: ${err?.message}`} />); 
      });
    }).catch((err) => {
      toast(({ closeToast }) => <ErrorToast message={`Error Creating Project : ${err.status}: ${err?.message}`} />); 
    });
    setProjectTitle('');
  }
  const fetchProjects = async() => {
    await API.getProjects().then(data => {
      let listproject = data.data?.map(item => {
        if (item.trackIds?.length > 0 && item.trackIds?.some(item1 => item1.mewoTrackId === props.trackToBeAddedToProject.trackId)) {
          item.isChecked = true;
        }
        return item;
      })
      setProjects(listproject);
      setTempProjects(listproject);
      setIsLoading(false);
    }).catch(err => {throw err});
  }
  const handleProjectTitle = async (e) => {
    if (e.key === 'Enter') {
      await createProject(projectTitle);
    }
  }

  const handleSearchProjects = (e) => {
    let { value } = e.target;
    setSearchKeyword(value);
    if (value !== '' && value.length > 1) {
      let filteredProjects = projects.filter(project => project.title.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      setProjects(filteredProjects);
    }

    if (value === '') {
      setProjects(tempProjects);
    }
  }

  const addProject = async() => {
    await createProject(projectTitle);
  }

  const addTrackToProjects = async() => {   
    if(!trackAddedProjects?.length)
      return;

    props.closeProjectModal();
    if (trackAddedProjects?.length) {
      let taskArr = [];
      trackAddedProjects.map(projectId => {
        taskArr.push(API.trackAddToProject(trackToBeAddedToProject, projectId).then(res => {
          if (res?.success)
            toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
          else
            Helper.handleError(res);
        }));
      });
      await Promise.allSettled(taskArr).then(res => {
      });
    }else{
      toast(({ closeToast }) => <InfoToast message={"No project(s) selected to add the track."} />);
    }
  }

  const addTrackToProject = async (projectId) => {
    await API.addTrackToProject(trackToBeAddedToProject, projectId).then(res => {
      toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
    }).catch((err) => {
      toast(({ closeToast }) => <ErrorToast message={err} />);
    });
  }

  const trackAddedToProject = (projectId, e) => {
    let isChecked = e.target.checked;
    let projectList = trackAddedProjects;
    if (isChecked && projectList.indexOf(projectId) < 0) {
      projectList.push(projectId);
    }
    else if (!isChecked && projectList.indexOf(projectId) >= 0) {
      var index = projectList.indexOf(projectId);    // <-- Not supported in <IE9
      projectList.splice(index, 1);
    }
    setTrackAddedProjects([...projectList]);
  }

  return (
    <div className='flex fixed top-16 lg:top-4 h-screen w-full subscribe-modal  justify-start  sm:justify-center' style={{ zIndex: '9' }}>
      <div className='self-center w-full lg:w-2/5 sm:w-3/5 shadow-xl rounded-2xl shadow-box p-4' style={{ background: 'rgba(255,255,255, 0,5)' }}>
        <div className='w-full flex -mt-24 md:mt-0 justify-centre mb-2'>
          <div className="w-full inline-block lg:text-start sm-padding-left lg:block">
            <span className={`w-8 h-8 p-2 mr-1 border self-center rounded-full linearGradient-0`}>
              <FolderCopyOutlinedIcon className='mb-1' style={{ fontSize: "22px", color: "white"}} />
            </span>
            <span className='album-label'>Add to Project</span>
          </div>
          <CancelIcon
            className="cursor-pointer"
            onClick={() => props.closeProjectModal()}
            style={{ fontSize: '24px' }}
          />
        </div>
        <div className='flex justify-end'>
        </div>
        <div className='pt-2'>
          <div className='w-full'>
            <div className='p-2 flex w-full pl-0 border-t border-gray-300 '>
              <div className="lg:text-left sm:text-center w-4/6 sm:w-9/12 sm:text-sm sm:self-center lg:block">
                <input
                  className='w-full rounded-2xl p-2 shadow-box add-icon'
                  placeholder='Enter Project Name'
                  onChange={event => { setProjectTitle(event.target.value) }}
                  onKeyDown={handleProjectTitle}
                  value={projectTitle}
                  
                />
              </div>
              {/* <div className="lg:text-right w-2/5 sm:w-3/12 sm:text-sm sm:self-center cursor-pointer lg:block ml-2">
              <div className={projectTitle?.length > 0 ? "greenbutton" : "button" }
                onClick={() => addProject()}
                disabled={!(projectTitle?.length > 0)} >
                  Add Project
                </div>
              </div> */}
              <div className="lg:text-right w-2/6 sm:w-3/12 sm:text-sm sm:self-center cursor-pointer lg:block ml-1">
                <button className={`py-1 px-3 text-center cursor-pointer border-0`}
                  style={{ fontSize: "14px", background: projectTitle?.length > 0 ? "rgb(var(--pink))" : "#dedede", color: projectTitle?.length > 0 ? "white" : "black"}}
                  // style={{ fontSize: "14px", background: "black", color: "white" }}
                  onClick={() => addProject()}
                  disabled={!(projectTitle?.length > 0)}
                >           
                  Add Project
                </button>
              </div>
            </div>
            {/* <input
              onChange={() => handleSearchProjects()}
              className='p-1 pl-2  mb-2 w-full text-l focus:outline-none bg-black border-b placeholder-white text-white'
              placeholder='Search projects'
            /> */}
            <div className="flex w-full justify-between px-2 pb-2 border-b border-gray-300">
              <div className="lg:text-left sm:w-6/12 lic-title sm:self-center sm:text-textGray-100 lg:block sm-box-align">
                My Projects
              </div>
              <div className="lg:text-center sm:w-3/12 lic-title sm:self-center sm:text-textGray-100  lg:block">
                Tracks
              </div>
              <div className="lg:text-center sm:w-3/12 lic-title sm:self-center sm:text-textGray-100 hidden md:block">
                Updated
              </div>
            </div>
            {isLoading && (
              <BouncingLoader />
            )}
            {projects?.length ? (
              <>
                <div className='lic-text' style={{ overflowY: "auto", height: height }}>
                  {projects.map((project, index) =>
                    <>
                      <div
                        key={project._id}
                        className='py-2 px-2
                  hover:bg-gray-200 cursor-pointer flex w-full justify-between border-b border-gray-300'>
                        <div className="lg:text-left sm:w-6/12 sm:text-sm sm:self-center lg:block sm-box-align">
                          <Checkbox
                            label='My checkbox'
                            labelstyle={{ color: 'black' }}
                            checked={project.isChecked}
                            onChange={(e) => trackAddedToProject(project._id, e)}
                            iconstyle={{ fill: 'black' }}
                            inputstyle={{ color: 'black' }}
                            style={{ color: 'black' }}
                          />
                          <Link to=''>
                            <span className='cursor-pointer'>{project.title}</span>
                          </Link>
                        </div>
                        <div className="lg:text-center sm:text-center sm:w-3/12 sm:text-sm sm:self-center mr-6 md:mr-0 lg:block">
                          {project.trackIds?.length}
                        </div>
                        <div className="lg:text-center sm:text-center sm:w-3/12 sm:text-sm sm:self-center hidden md:block">
                          {dayjs(project.updatedAt).format('DD.MM.YYYY')}
                        </div>

                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (!isLoading) && (
              <div className="text-xl text-center text-red-500 p-5">No Projects Found</div>
            )}
          </div>
        </div>
        <div className="flex flex-wrap align-center pt-2 w-full">
          
          {/* <div className={"cursor-pointer " + (trackAddedProjects?.length > 0 ? "greenbutton" : "button px-4")}
            onClick={() => {addTrackToProjects()}}
            disabled={!(trackAddedProjects?.length > 0)} 
            style={{
              width : "120px"
            }}
          >
              Save
          </div> */}
          <div className='w-3/6 flex justify-start items-center pl-3' >
            <span className='lic-text'>{trackAddedProjects?.length}&nbsp; Projects selected</span>
          </div>
          <div className='w-3/6 flex justify-end pt-3' >
            <button className={`py-1 px-3 text-center cursor-pointer border-0`}
              style={{ fontSize: "14px", background: "black", color: "white"}}
              onClick={() => props.closeProjectModal()}
            >           
              Cancel
            </button>

            <button className={`py-1 px-5 text-center cursor-pointer border-0`}
              style={{ fontSize: "14px", background: trackAddedProjects?.length > 0 ? "rgb(var(--pink))" : "#dedede", color: trackAddedProjects?.length > 0 ? "white" : "black"}}
              onClick={() => {addTrackToProjects()}}
            >           
              {/* <SaveIcon className='mr-1 mb-1' /> */}
              Save
            </button>
          </div>
        </div>

      </div>
    </div>

  )
}

export default AddTrackToProjectPopup;